<template>
  <!-- 离职 -->
  <div class="detail">
    <ax-panel :noTitle="true">
      <van-cell
        title="姓名"
        :value="data.header.emplid_description"
      ></van-cell>
      <van-cell
        title="员工类型"
        :value="data.header.empl_class_description"
      ></van-cell>
      <van-cell
        title="所属部门"
        :value="data.header.deptid_description"
      ></van-cell>
      <van-cell
        title="职位"
        :value="data.header.qh_external_posn"
      ></van-cell>
      <van-cell
        title="层级"
        :value="data.header.qh_cj_code_description"
      ></van-cell>
      <van-cell
        title="司龄（年）"
        :value="data.header.qh_day_wk_tm"
      ></van-cell>
      <van-cell
        title="离职原因"
        :value="data.header.qh_ter_act_reason_description"
      ></van-cell>
      <!-- <van-cell
        title="最后工作日"
        :value="data.header.termination_dt"
      ></van-cell> -->
      <!-- <van-cell
        title="年假剩余天数预算"
        :value="data.header.qh_ann_balanc_day"
      ></van-cell> -->
    </ax-panel>
    <!-- 业务意见 -->
    <ax-panel title="业务意见">
      <!-- 预计离职日期 -->
      <van-cell
        v-if="action"
        is-link
        @click="showLastDate=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">预计离职日期</span>
          <!-- qh_hr_011_head.last_date_worked -->
        </template>
        <span>{{lastDate}}</span>
      </van-cell>
      <van-popup
        v-model="showLastDate"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-datetime-picker
          v-model="minDate"
          type="date"
          @confirm="confirmLastDate"
          @cancel="showLastDate=false"
          :formatter="formatter"
        />
      </van-popup>
      <van-cell
        v-if="!action"
        title="预计离职日期"
        :value="this.data.header.last_date_worked"
      />
      <van-cell>
        <p class="desc">此日期为员工最终的离职日期，请提示员工在此日期前完成工作交接并提交休假申请休完剩余假期。</p>
      </van-cell>
      <!-- <van-cell
        v-if="action"
        title="年假剩余天数"
        :value="this.leaveData.qh_ann_balanc_day1"
      /> -->
      <!-- <van-cell
        v-if="action"
        title="预计离职证明领取日期"
        :value="this.leaveData.qh_leave_cert_dt1"
      /> -->
      <!-- <van-cell
        v-if="!action"
        title="年假剩余天数"
        :value="this.data.header.qh_ann_balanc_day1"
      /> -->
      <!-- <van-cell
        v-if="!action"
        title="预计离职证明领取日期"
        :value="this.data.header.qh_leave_cert_dt1"
      /> -->
      <!-- 是否竞业 -->
      <van-cell
        v-if="action"
        is-link
        :value="jyValue"
        @click="isjy=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">是否竞业</span>
          <!-- qh_hr_011_head.checked -->
        </template>
      </van-cell>
      <van-popup
        v-model="isjy"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          show-toolbar
          :columns="jyActions"
          @confirm="onJySelect"
          @cancel="isjy=false"
        />
      </van-popup>
      <van-cell
        v-if="!action"
        title="是否竞业"
        :value="yesOrNo(this.data.header.checked)"
      />
      <!-- 是否进行离任审计 -->
      <div v-if="ifAudit(data.header.qh_cj_code_description)">
        <van-cell
          v-if="action"
          is-link
          :value="sjValue"
          @click="issj=true"
        >
          <template #title>
            <span style="color:red">*&nbsp;</span>
            <span class="custom-title">是否进行离任审计</span>
            <!-- qh_hr_011_head.check_char -->
          </template>
        </van-cell>
        <van-popup
          v-model="issj"
          position="bottom"
          :style="{ height: '30%' }"
        >
          <van-picker
            show-toolbar
            :columns="sjActions"
            @confirm="onSjSelect"
            @cancel="issj=false"
          />
        </van-popup>
        <!-- todo确认字段 -->
        <van-cell
          v-if="!action"
          title="是否进行离任审计"
          :value="yesOrNo(this.data.header.check_char)"
        />
        <van-cell>
          <p class="desc">M5及以上级别，原则上离职时必须启动离任审计。如不启动离任审计，需事先得到CEO及主管内审工作副总裁的书面审批；其他M5级别以下员工离职（岗）时，公司视需要由人力资源部报 CEO 批准后对其启动离职（岗）审计。</p>
        </van-cell>
      </div>
      <!-- 代码行为分析 -->
      <van-cell
        v-if="action"
        is-link
        :value="tdValue"
        @click="istd=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">代码行为分析</span>
          <!-- qh_hr_011_head.checklist_btn -->
        </template>
      </van-cell>
      <van-popup
        v-model="istd"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          show-toolbar
          :columns="tdActions"
          @confirm="onTdSelect"
          @cancel="istd=false"
        />
      </van-popup>
      <van-cell
        v-if="!action"
        title="代码行为分析"
        :value="yesOrNo(this.data.header.checklist_btn)"
      />
      <van-cell>
        <p class="desc">调查员工离职前三个月内对代码库的批量操作行为，如浏览，下载等。（一般适用于产品代码有操作权限的技术相关人员）
        </p>
      </van-cell>
      <!-- 请判断是否邮件转发 -->
      <van-cell
        v-if="action"
        is-link
        :value="yjValue"
        @click="isyj=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">请判断是否邮件转发</span>
          <!-- qh_hr_011_head.qh_check_wrok_tsf -->
        </template>
      </van-cell>
      <van-popup
        v-model="isyj"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          show-toolbar
          :columns="yjActions"
          @confirm="onYjSelect"
          @cancel="isyj=false"
        />
      </van-popup>
      <van-cell
        v-if="!action"
        title="请判断是否邮件转发"
        :value="yesOrNo(this.data.header.qh_check_wrok_tsf)"
      />
      <van-cell>
        <p class="desc">离职员工账号关闭后，新邮件自动转至承接员工（仅限高级管理人员及销售市场员工，期限不超过6个月）
        </p>
      </van-cell>
      <!-- 承接方员工编号 -->
      <van-cell
        v-show="action&&showCarry"
        is-link
        :value="name"
        @click="showSearch=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">承接方员工编号</span>
          <!-- qh_hr_011_head.qh_work_trsfer_id -->
        </template>
        <template #right-icon>
          <van-icon
            name="search"
            style="position: absolute;right: 0.15rem;line-height:0.64rem"
          />
        </template>
      </van-cell>
      <van-popup
        v-model="showSearch"
        position="bottom"
        :style="{ height: '70%' }"
      >
        <van-search
          show-action
          v-model="nameValue"
          placeholder="请输入员工姓名"
          @search="onSearchName"
        >
          <template #action>
            <van-button
              type="info"
              @click="onSearchName"
            >搜索</van-button>
          </template>
        </van-search>
        <van-cell
          v-for="item in nameList"
          :key="item.employee_id"
          :title="item.employee_id+' '+item.name"
          :value="item.department"
          @click="choseName(item.name,item.employee_id)"
        />
      </van-popup>
      <van-cell
        v-if="!action&&ifMail"
        title="承接方员工编号"
        :value="this.data.header.qh_work_trsfer_id"
      />
      <!-- 转发生效日期 -->
      <van-cell
        v-show="action&&showCarry"
        is-link
        :value="startDate"
        @click="showStartDate=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">转发生效日期</span>
          <!-- qh_hr_011_head.qh_work_trsfer_dt -->
        </template>
      </van-cell>
      <van-popup
        v-model="showStartDate"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-datetime-picker
          type="date"
          v-model="minDate"
          @confirm="confirmStartDate"
          @cancel="showStartDate=false"
          :formatter="formatter"
        />
      </van-popup>
      <van-cell
        v-if="!action&&ifMail"
        title="转发生效日期"
        :value="this.data.header.qh_work_trsfer_dt"
      />
      <!-- 转发结束日期 -->
      <van-cell
        v-show="action&&showCarry"
        is-link
        :value="overDate"
        @click="showOverDate=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">转发结束日期</span>
          <!-- qh_hr_011_head.qh_work_tsf_end_dt -->
        </template>
      </van-cell>
      <van-popup
        v-model="showOverDate"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-datetime-picker
          type="date"
          v-model="minDate"
          @confirm="confirmOverDate"
          @cancel="showOverDate=false"
          :formatter="formatter"
        />
      </van-popup>
      <van-cell
        v-if="!action&&ifMail"
        title="转发结束日期"
        :value="this.data.header.qh_work_tsf_end_dt"
      />
      <!-- 是否组织离职联欢会 -->
      <van-cell
        v-if="lhcAction"
        is-link
        :value="lhValue"
        @click="islh=true"
      >
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">是否组织离职联欢会</span>
          <!-- qh_hr_011_head.qh_is_hsp -->
        </template>
      </van-cell>
      <van-popup
        v-model="islh"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          show-toolbar
          :columns="lhActions"
          @confirm="onLhSelect"
          @cancel="istd=false"
        />
      </van-popup>
      <van-cell
        v-if="lhAction"
        title="是否组织离职联欢会"
        :value="yesOrNo(this.data.header.qh_is_hsp)"
      />
    </ax-panel>
    <!-- HRBP意见 -->
    <ax-panel
      title="HRBP意见"
      v-if="!noHRBP"
    >
      <!-- 与员工直接上级确认 -->
      <van-cell>
        <p class="desc">
          已与员工直接上级沟通并确认，以上最后工作日期
        </p>
      </van-cell>
      <van-cell
        title="与员工直接上级确认"
        :value="data.header.qh_hrbp_flag==='Y'?'确认无误':'有误，需回退至直接上级'"
      ></van-cell>
      <!-- data.header.qh_hrbp_flag -->
      <!-- 是否竞业 -->
      <van-cell
        title="是否竞业"
        :value="yesOrNo(data.header.qh_hrbp_flag1)"
      ></van-cell>
      <!-- data.header.qh_hrbp_flag1 -->
    </ax-panel>

    <!-- 离职面谈信息-->
    <ax-panel
      title="离职面谈信息"
      v-if="!noHRBP"
    >
      <!-- 操作 -->
      <van-cell
        title="操作"
        :value="data.header.action_description"
      ></van-cell>
      <!-- data.header.action -->
      <!-- data.header.action_description -->
      <!-- 首要离职原因 -->
      <van-cell
        title="首要离职原因"
        :value="data.header.action_reason_description"
      ></van-cell>
      <!-- data.header.reason -->
      <!-- data.header.reason_description -->
      <!-- 次要离职原因 -->
      <van-cell
        title="次要离职原因"
        v-show="this.cy_action_reason_description"
        :value="cy_action_reason_description"
      ></van-cell>
      <!-- data.header.action_reason -->
      <!-- data.header.action_reason_description -->
      <!-- 请详细描述员工的离职原因（请举例说明） -->
      <van-cell style="border-bottom:none">
        <p class="title">请详细描述员工的离职原因（请举例说明）</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_comments_005}}</p>
      <!-- data.header.qh_comments_005 -->
    </ax-panel>
    <ax-panel
      :noTitle="true"
      v-if="!noHRBP"
    >
      <!-- 是否尝试挽留 -->
      <van-cell
        title="是否尝试挽留"
        v-show="!isStu"
        :value="yesOrNo(data.header.qh_hrbp_flag2)"
      />
      <!-- data.header.qh_hrbp_flag2 -->
      <!-- 挽留说明 -->
      <van-cell
        style="border-bottom:none"
        v-show="data.header.qh_hrbp_flag2==='Y'&&!isStu"
      >
        <p class="title">挽留说明</p>
      </van-cell>
      <p
        v-show="data.header.qh_hrbp_flag2==='Y'&&!isStu"
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_comments_006}}</p>
      <!-- data.header.qh_comments_006 -->
    </ax-panel>
    <ax-panel
      :noTitle="true"
      v-if="!noHRBP&&!isStu"
    >
      <!-- 入职前的期望，入职后有哪些落差 -->
      <van-cell style="border-bottom:none">
        <p class="title">入职前的期望，入职后有哪些落差，以及工作岗位中遇到了那些困难</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_comments_007}}</p>
      <!-- data.header.qh_comments_007 -->
    </ax-panel>
    <ax-panel
      :noTitle="true"
      v-if="!noHRBP&&!isStu"
    >
      <!-- 离职去向 -->
      <van-cell style="border-bottom:none">
        <p class="title">离职去向（公司名称、行业、规模、薪酬变化）</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_comments_008}}</p>
      <!-- data.header.qh_comments_008 -->
    </ax-panel>
    <!-- 对公司的意见和建议 -->
    <ax-panel
      :noTitle="true"
      v-if="!noHRBP&&!isStu"
    >
      <van-cell style="border-bottom:none">
        <p class="title">对公司的意见和建议</p>
      </van-cell>
      <p
        class="desc"
        style="margin-bottom:20px"
      >{{data.header.qh_comments_009}}</p>
      <!-- data.header.qh_comments_009 -->
    </ax-panel>
    <!-- 返回上一节点 -->
    <ax-panel
      :noTitle="true"
      v-if="!noHRBP"
    >
      <div
        style="padding:.1rem .1rem"
        @click="lastNode"
        v-if="data.action === 'U'"
      >
        <van-button
          color="#3873fa"
          plain
          block
        >返回上一节点</van-button>
      </div>
    </ax-panel>
  </div>
</template>

<script>
import moment from 'moment';
import request from '@/utils/request';
import watermark from '../../utils/warterMark';
import doNext from '@/mixins/doNext';
export default {
  props: ['data', 'pageObj', 'comments'],
  mixins: [doNext],
  data() {
    return {
      action: true,
      lhcAction: false,
      lhAction: false,
      noHRBP: false,
      showCarry: false,
      ifMail: true,
      minDate: new Date(),
      showSearch: false,
      showLastDate: false,
      lastDate: '请选择',
      showStartDate: false,
      startDate: '请选择',
      showOverDate: false,
      overDate: '请选择',
      isjy: false,
      issj: false,
      istd: false,
      islh: false,
      isyj: false,
      isok: false,
      isms: false,
      isopt: false,
      isfir: false,
      issec: false,
      isdet: false,
      name: '',
      nameValue: '',
      jyValue: '请选择',
      sjValue: '请选择',
      tdValue: '请选择',
      lhValue: '请选择',
      yjValue: '请选择',
      firstValue: '请选择',
      // optValue: '操作',
      // secValue: '次要原因',
      // firValue: '首要原因',
      jyActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      sjActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      tdActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      lhActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      yjActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      okActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      msActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      optActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      firActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      secActions: [
        { text: '是', code: 'Y' },
        { text: '否', code: 'N' }
      ],
      secListResult: [],
      secList: [],
      nameList: [],
      leaveData: {
        last_date_worked: '',
        qh_ann_balanc_day1: '',
        qh_leave_cert_dt1: '',
        checked: '',
        check_char: '',
        checklist_btn: '',
        qh_check_wrok_tsf: '',
        qh_work_trsfer_id: '',
        qh_work_trsfer_dt: '',
        qh_work_tsf_end_dt: '',
        qh_is_hsp: ''
      },
      cy_action_reason_description: '',
      isStu: false // 判断是不是实习生
    };
  },
  watch: {
    data() {
      this.lhcAction =
        this.data.field_special_deal.qh_is_hsp_visible &&
        this.data.field_special_deal.qh_is_hsp_enabled;
      this.lhAction =
        this.data.field_special_deal.qh_is_hsp_visible &&
        !this.data.field_special_deal.qh_is_hsp_enabled;
      const current_oprid = this.data.current_oprid;
      const step_node = JSON.parse(this.data.step_node);
      // 当前用户和第一个节点是同一个人
      const isOne = step_node[0].actual[0] === current_oprid;
      if (isOne) {
        if (step_node.length < 3) {
          this.noHRBP = true;
        } else {
          if (this.getSameNodeTime(step_node, current_oprid) === 1)
            this.noHRBP = true;
        }
        console.log(this.noHRBP);
      }
      let edit = true;
      if (step_node[0].status !== 'P') {
        step_node.forEach((item) => {
          if (item.status === 'P') {
            edit = false;
          }
        });
      }
      this.action = this.data.action === 'U' && edit;
      if (!this.action && this.data.header.qh_check_wrok_tsf === 'N') {
        this.ifMail = false;
      }
      this.cy_action_reason_description = this.data.qh_hr_res_dtl[0].action_reason_description;
      // 判断是不是实习生
      this.data.header.empl_class === '05' ||
      this.data.header.empl_class === '06' ||
      this.data.header.empl_class === '08'
        ? (this.isStu = true)
        : '';
      // 水印
      this.$nextTick(() => {
        const name = this.data.current_user;
        const now = new Date();
        const date = `${now.getFullYear()}/${
          now.getMonth() + 1
        }/${now.getDate()} ${now.getHours()}:${
          now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
        }`;
        watermark.set(date + name);
      });
    }
  },
  methods: {
    // 获取相同节点数
    getSameNodeTime(nodes, id) {
      let num = 0;
      nodes.forEach((item) => {
        if (item.actual[0] === id) {
          num++;
        }
      });
      return num;
    },
    // 父组件通过ref获取子组件的leaveData
    returnLeaveData() {
      this.$emit('getLeaveData', this.leaveData, this.action);
    },
    // 只读过滤是否的过滤器
    yesOrNo(str) {
      return str ? (str === 'Y' ? '是' : '否') : '';
    },
    // 是否需要审计
    ifAudit(str) {
      return ['M5','M6','M7','M8','M9','M10','S11','S12','S13','S14'].includes(str)
    },
    formatDate(date) {
      return moment(date).format('YYYY/MM/DD');
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
    onSearchName() {
      if (!this.nameValue) {
        this.$toast({
          message: '请输入承接方员工',
          duration: 1500
        });
      } else {
        this.$toast.loading({
          message: '加载中...'
        });
        const options = {
          url: '/treasure/ehr/leaveOffice/DoTransferWorkList',
          method: 'post'
        };
        let body = {
          name: this.nameValue
        };
        if (this.pageObj.data) {
          this.pageObj.data.forEach((item) => {
            body[item[0]] = this[item[1]];
          });
        }
        if (this.pageObj.method === 'get') {
          options.params = body;
        } else {
          options.data = body;
        }
        request(options)
          .then(({ data }) => {
            this.$toast.clear();
            if (data.code === 200) {
              this.nameList = data.data;
            } else {
              this.$toast.fail({
                message: data.message,
                duration: 1500
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    choseName(name, id) {
      this.name = name;
      this.showSearch = false;
      this.leaveData.qh_work_trsfer_id = id;
    },
    // 预计离职日期
    confirmLastDate(date) {
      this.showLastDate = false;
      this.lastDate = this.formatDate(date);
      this.leaveData.last_date_worked = this.lastDate;
      this.$toast.loading({
        message: '加载中...'
      });
      const options = {
        url: '/treasure/ehr/leaveOffice/DoCalcAnnualLeave',
        method: 'post'
      };
      let body = {
        emplid: this.data.header.emplid,
        termination_dt: this.lastDate
      };
      if (this.pageObj.data) {
        this.pageObj.data.forEach((item) => {
          body[item[0]] = this[item[1]];
        });
      }
      if (this.pageObj.method === 'get') {
        options.params = body;
      } else {
        options.data = body;
      }
      request(options)
        .then(({ data }) => {
          this.$toast.clear();
          console.log(data);
          if (data.code === 200) {
            this.leaveData.qh_ann_balanc_day1 = data.data.qh_ann_balanc_day;
            this.leaveData.qh_leave_cert_dt1 = data.data.qh_leave_cert_dt;
          } else {
            this.$toast.fail({
              message: data.message,
              duration: 1500
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 承接转发开始日期
    confirmStartDate(date) {
      this.showStartDate = false;
      this.startDate = this.formatDate(date);
      this.leaveData.qh_work_trsfer_dt = this.startDate;
    },
    // 承接结束日期
    confirmOverDate(date) {
      this.showOverDate = false;
      this.overDate = this.formatDate(date);
      this.leaveData.qh_work_tsf_end_dt = this.overDate;
    },
    // 是否竞业
    onJySelect(item) {
      this.isjy = false;
      this.jyValue = item.text;
      this.leaveData.checked = item.code;
    },
    // 是否进行离任审计
    onSjSelect(item) {
      this.issj = false;
      this.sjValue = item.text;
      this.leaveData.check_char = item.code;
    },
    // 代码行为分析
    onTdSelect(item) {
      this.istd = false;
      this.tdValue = item.text;
      this.leaveData.checklist_btn = item.code;
    },
    // 离职联欢
    onLhSelect(item) {
      this.islh = false;
      this.lhValue = item.text;
      this.leaveData.qh_is_hsp = item.code;
    },
    // 请判断是否邮件转发
    onYjSelect(item) {
      this.isyj = false;
      this.yjValue = item.text;
      this.leaveData.qh_check_wrok_tsf = item.code;
      this.leaveData.qh_check_wrok_tsf === 'Y'
        ? (this.showCarry = true)
        : (this.showCarry = false);
    },
    // 返回上一节点
    lastNode() {
      if (!this.comments) {
        this.$toast({
          message: '请输入审批意见',
          duration: 1500
        });
        return;
      }
      const instId = this.$route.query.instanceId;
      const version = this.$route.query.version || 0.0;
      const pageId = this.$route.query.pageId;
      const path = this.pageObj.path || '';
      if (Object.prototype.toString.call(version) === '[object Array]') {
        version = version[1] ? version[1] : version;
      }
      const query = {
        jumpType: 'BACK',
        instId: instId,
        version: version,
        platform: 'ehr',
        opinion: this.comments,
        jsonData: {
          service_type: path || pageId,
          emplid: this.data.header.emplid,
          empl_rcd: this.data.header.empl_rcd,
          action_dt_ss: this.data.header.action_dt_ss,
          effseq: this.data.header.effseq,
          comments: this.comments
        },
        extJsonData: ''
      };
      query.jsonData = JSON.stringify(query.jsonData);
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定返回上一节点?',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              this.handleDoNext(query, '返回成功', done)
            } else {
              done();
            }
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
</style>